module.exports = "<div class=\"m-link-slick container-fluid\">\r\n    <a :href=\"o.link\" v-for=\"o in images\">\r\n        <div class=\"item g-ratio-box\">\r\n            <img :data-lazy=\"o.imgs | cdnImageOrg\" style=\"display: none;\">\r\n        </div>\r\n    </a>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!../common/component/image-link-slick.html
// module id = 104
// module chunks = 2 3 7 8 12